<template>
  <BaseSection>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeInBottom"
        data-animation-delay="100"
        text="Благодарим за&nbsp;участие в&nbsp;курсе!"
      />
    </template>
    <template #content>
      <BaseText
        size="m"
        data-animation="fadeInRight"
        data-animation-delay="300"
        v-html="'Если вам понравилось обучение и&nbsp;вы желаете оставить обратную связь, поблагодарить авторов или просто написать нам, воспользуйтесь <br><b>формой обратной связи:</b>'"
      />
      <div class="section__gap section__gap_double" data-animation="fadeIn" data-animation-delay="600">
        <TheFeedbackForm class="section__form" />
      </div>
      <div class="section__gap section__gap_double" data-animation="fadeInBottom" data-animation-delay="900">
        <TheBonusBanner />
      </div>
      <div class="section__gap section__gap_double" data-animation="fadeInRight" data-animation-delay="1200">
        <TheLinks :items="links" />
      </div>
      <div class="section__gap section__gap_double">
        <BaseText
          data-animation="fadeInRight"
          data-animation-delay="1500"
          v-html="about"
        />
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import TheFeedbackForm from '@/components/TheFeedbackForm.vue';
import TheBonusBanner from '@/components/TheBonusBanner.vue';
import TheLinks from '@/components/TheLinks.vue';

export default {
  name: 'FeedbackPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    TheFeedbackForm,
    TheBonusBanner,
    TheLinks,
  },
  staticData: () => ({
    links: [
      {
        name: 'Бесплатная экспресс&#8209;оценка существующего курса',
        href: '/evaluation',
      },
      {
        name: 'Памятка по работе над&nbsp;дистанционным курсом',
        href: 'https://yandex.ru/',
      },
      {
        name: 'Бесплатная подборка полезных приложений для&nbsp;удаленщиков',
        href: '/apps',
      },
      {
        name: 'Telegram&#8209;стикеры для HR на&nbsp;злободневные темы',
        href: 'https://web.telegram.org/',
      },
    ],
    about: 'Команда <a href="https://77experts.com/" target="_blank" class="link"><b>77 experts</b></a> cоздает рекламный и&nbsp;образовательный контент, организует и&nbsp;сопровождает офлайн- и&nbsp;онлайн&#8209;мероприятия любой сложности для внутрикорпоративных, партнерских и клиентских целей. Среди&nbsp;клиентов – ПАО&nbsp;«НОРНИКЕЛЬ», АО&nbsp;«Газпромбанк», ПАО&nbsp;«ВымпелКом» и др.',
  }),
};
</script>
